import React, { Fragment, useState } from "react";
import { Dialog, Transition } from "@headlessui/react";
import ShareIntroModal from "../../components/share-into-modal/component";
import ShareWithOthersModal from "../../components/share-with-others-modal/component";

const Share = () => {
  const [showShareModal, setShowShareModal] = useState(true);
  const toggleShareModal = (t) => setShowShareModal(t);
  const [showShareWithOthersModal, setShowShareWithOthersModal] = useState(false);
  const toggleShareWithOthersModal = (a) => setShowShareWithOthersModal(a);

  return (
    <div className="sharesimpli-wrap">
      <ShareIntroModal
        showShareModal={showShareModal}
        toggleShareModal={toggleShareModal}
        toggleShareWithOthersModal={toggleShareWithOthersModal}
      />
      <ShareWithOthersModal show={showShareWithOthersModal} toggleShareWithOthersModal={toggleShareWithOthersModal} />
    </div>
  );
};

export default Share;
